import { Data_getInstancerqv28wl75vgy as Data_getInstance } from './adapter/DeletePairAssignmentsMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeletePairAssignmentsMutation_VariablesAdapter_instance2a4v59l4sghc6 as DeletePairAssignmentsMutation_VariablesAdapter_instance } from './adapter/DeletePairAssignmentsMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deletePairAssignments) {
        this.l6g_1 = deletePairAssignments;
      }
      toString() {
        return 'Data(deletePairAssignments=' + this.l6g_1 + ')';
      }
      hashCode() {
        return this.l6g_1 == null ? 0 : getBooleanHashCode(this.l6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.l6g_1 == other.l6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.m6g_1 = '5f431795769da9adf5424eb986e567d7f3d0c969eea1d72c008a4cdfcc11adf1';
        this.n6g_1 = 'deletePairAssignments';
      }
      g6g() {
        return 'mutation deletePairAssignments($input: DeletePairAssignmentsInput!) { deletePairAssignments(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DeletePairAssignmentsMutationClass;
function DeletePairAssignmentsMutation() {
  if (DeletePairAssignmentsMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.o6g_1 = input;
      }
      i6g() {
        return '5f431795769da9adf5424eb986e567d7f3d0c969eea1d72c008a4cdfcc11adf1';
      }
      operationId() {
        return this.i6g();
      }
      w48() {
        return Companion_instance.g6g();
      }
      j6g() {
        return 'deletePairAssignments';
      }
      operationName() {
        return this.j6g();
      }
      q47(writer, customScalarAdapters, withDefaultValues) {
        DeletePairAssignmentsMutation_VariablesAdapter_instance.p6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      p47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'DeletePairAssignmentsMutation(input=' + this.o6g_1.toString() + ')';
      }
      hashCode() {
        return this.o6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePairAssignmentsMutation()))
          return false;
        if (!this.o6g_1.equals(other.o6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePairAssignmentsMutation', VOID, VOID, [Mutation()]);
    DeletePairAssignmentsMutationClass = $;
  }
  return DeletePairAssignmentsMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data245eeyny59bq1,
  DeletePairAssignmentsMutation as DeletePairAssignmentsMutationfwlgebyv0y4l,
};
//endregion

//# sourceMappingURL=DeletePairAssignmentsMutation.mjs.map
